import React, { useCallback, useState } from 'react'
import { BatteryProviderContext } from 'src/Libs/batteries/providers/context'
import { BatteryProviderContextProps } from 'src/Libs/batteries/providers/types'
import { FarmBatteryModel } from 'src/Libs/batteries'

const BatteryProvider: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const [batteriesInStorage, setBatteriesInStorage] = useState<Map<string, FarmBatteryModel[]>>(new Map())

  const setValues = useCallback(
    (storageSerialId: string, values: FarmBatteryModel[]): void => {
      const newMap = new Map(Array.from(batteriesInStorage.entries()))
      newMap.set(storageSerialId, values)
      setBatteriesInStorage(newMap)
    },
    [batteriesInStorage]
  )

  const providerValue = { batteries: batteriesInStorage, setBatteries: setValues } as BatteryProviderContextProps

  return <BatteryProviderContext.Provider value={providerValue}>{children}</BatteryProviderContext.Provider>
}

export default BatteryProvider
